module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.newAgreement) ? _c('div', {
    staticClass: "Vagreement"
  }, [_c('div', [_c('h5', [_vm._v(_vm._s(_vm.newAgreement)), _c('div', {
    on: {
      "click": _vm.check
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "Valert-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail)
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.check
    }
  }, [_vm._v("确认")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffa0ee7e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component/agreement.vue
// module id = 58
// module chunks = 70